var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "leftMenu" },
    [
      _c("TreeMenu", {
        ref: "TreeMenu",
        attrs: {
          menuData: _vm.MenuList,
          fieldMap: _vm.fieldMap,
          active: _vm.activeIndex,
        },
        on: { select: _vm.select },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }